// @core/api/endpoints/workflow/list_pending_decisions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPendingDecisionsResponse,
} from '../../../types/workflow';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/workflow';

/**
 * List pending decisions
 * Returns everything awaiting an actor across all pipelines, so approvals can be found without knowing which pipeline they belong to.
 */
export async function ListPendingDecisions(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPendingDecisionsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/decisions`;
  const requestOptions = options;
  return client.get<ListPendingDecisionsResponse>(requestPath, { ...requestOptions, params });
}
